import { TDateRangeField } from '../components/types';
import { TSearchTabsFilters } from 'src/components/Search/components/types';

export const MAINTENANCE_PACKAGE_DATE_RANGE_FIELD: TDateRangeField[] = [
    'createdAt',
];

export const MAINTENANCE_PACKAGES_TABS_FILTERS: TSearchTabsFilters[] = [
    { key: 'all', label: 'Tabs.All' },
];

export const NO_DISPLAYABLE_MAINTENANCE_PACKAGE_FILTERS = [
    'page',
    'limit',
    'isSearching',
    'isQueryEnabled',
    'isTabsEnabled',
    'tabValue',
];
